import { For, Match, Show, Switch, createMemo } from "solid-js";
import Flexbox from '../../st-flexbox/st-flexbox'
import Icon from "../../st-icon/st-icon";
import { requireWizardContext } from "../WizardContext";
import btnStyles from '../../st-button/st-button.module.css';

export function ControlPanel() {
    const ctx = requireWizardContext();
    const currentStep = createMemo(() => ctx.steps()[ctx.currStep()]);

    // `middle` on each button is what vertically centres the chevron against its label. Without it
    // the icon and the <span> sit on the flex line's default `align-items: stretch`, so the chevron
    // renders top-aligned against a taller text box and the arrow looks like it is floating above
    // the word. Flexbox's own `middle` prop maps to align-items: center
    // (base-flexbox.module.css:49-51), so this uses the component's API rather than a bolted-on
    // style that would drift if that class ever changes.
    return <Flexbox padded dir="horizontal">
        <Flexbox.Item>
            <Flexbox middle as="button" dir="horizontal" disabled={!ctx.hasPreviousStep()} class={btnStyles.btn} data-type="default" onClick={() => ctx.selectPrevStep()} >
                <Icon src="fas fa-chevron-left" />
                <span>Previous</span>
            </Flexbox>
        </Flexbox.Item>
        <Flexbox.Item>
            <Show when={ctx.hasNextStep()}>
                <Flexbox middle disabled={!currentStep().completed()} as="button" dir="horizontal" class={btnStyles.btn} data-type="primary" onClick={() => ctx.selectNextStep()}>
                    <span>Next</span>
                    <Icon src="fas fa-chevron-right" />
                </Flexbox>
            </Show>
            <Show when={!ctx.hasNextStep() && ctx.hasOnComplete} >
                <Flexbox middle as="button" dir="horizontal" class={btnStyles.btn} data-type="primary" onClick={() => ctx.onComplete!()}>
                    <span>Complete</span>
                    <Icon src="fas fa-chevron-right" />
                </Flexbox>
            </Show>
        </Flexbox.Item>
        <Flexbox.Item auto />
        <Show when={!!ctx.onCancel}>
            <Flexbox.Item>
                <Flexbox middle as="button" dir="horizontal" class={btnStyles.btn} data-type="link" onClick={() => ctx.onCancel!()} >
                    <span>Cancel</span>
                </Flexbox>
            </Flexbox.Item>
        </Show>
    </Flexbox>
}
